import {FarmModel} from '../../model/farms/FarmModel.js';
import {BaseCollection} from '../BaseCollection';
import {PermissionCollection} from '../users/PermissionCollection';
import {BaseFilterModel} from '../../model/filter/BaseFilterModel';
import {CURRENT_USER} from '../../../js/resources/SessionObjects';
import {PermissionModel} from '../../model/users/PermissionModel';

/**
 * @class FarmCollection
 * @extends BaseCollection
 */
export class FarmCollection extends BaseCollection {

    get model () {

        return FarmModel;
    }

    initialize (models, options) {

        super.initialize(models, options);

        this.microservice = 'farms';
        this.resource = 'v2/farms';
    }

    comparator (farm1, farm2) {

        let uuid1 = farm1.get('uuid');
        let name1 = (farm1.get('name') ? farm2.get('name').toLowerCase() : undefined);
        let uuid2 = farm2.get('uuid');
        let name2 = (farm2.get('name') ? farm2.get('name').toLowerCase() : undefined);

        if (uuid1 === 'dashboard') {
            return -1;
        }

        if (uuid2 === 'dashboard') {
            return 1;
        }

        if (name1 > name2) {
            return 1;
        }

        if (name1 < name2) {
            return -1;
        }

        return 0;
    }

    static cmpByFarmName (a, b) {
        
        const name1 = a.get('name').toLowerCase();
        const name2 = b.get('name').toLowerCase();
        const first = -1, second = 1, same = 0;

        if( name1 > name2) {
            return second;
        } else if (name2 > name1) {
            return first;
        } else {
            return same;
        }
    }

    update (options) {

        let deferred = $.Deferred();

        super
            .update(options)
            .done(() => {

                if (!this.length) {
                    deferred.resolve();
                } else {

                    let permissions = new PermissionCollection([], {
                        filterParams: new BaseFilterModel({
                            granteeUuid: CURRENT_USER.get('uuid'),
                            objectType: PermissionModel.OBJECT_TYPE.FARM
                        })
                    });

                    permissions
                        .update()
                        .done(() => {

                            permissions.each((permission) => {

                                let farm = this.find({uuid: permission.get('objectUuid')});

                                if (farm) {
                                    farm.set('access', permission.get('access'));
                                }
                            });

                            deferred.resolve();
                        })
                        .fail(() => {
                            deferred.reject();
                        });
                }
            })
            .fail(() => {
                deferred.reject();
            });

        return deferred;
    }

    checkIfAllWriteOrShareAccess () {

        return _.every(this.map((farm) => farm.hasWriteOrShareAccess()));
    }

    fetchFarmOwners () {

        let uniqueFarmOwners = _.uniq(this.map((farm) => farm.get('creatorId')));

        if (uniqueFarmOwners && uniqueFarmOwners.length) {

            $.ajax({
                url: (API_PREFIX + `/users/users?uuid=${uniqueFarmOwners}`),
                type: 'GET',
                dataType: 'json',
                contentType: 'application/json'
            })
            .done((response) => {

                this.each((farm) => {
                    let farmOwner = _.find(response, (owner) => owner.uuid === farm.get('creatorId'));

                    if (farmOwner) {

                        farm.set('farmOwnerName', `${farmOwner.firstName}${farmOwner.lastName ?
                            ' ' + farmOwner.lastName : ''}`);
                    }
                });
            });
        }
    }
}


// WEBPACK FOOTER //
// ./shared/collection/farms/FarmCollection.js